import { render, staticRenderFns } from "./indicatorType.vue?vue&type=template&id=dc86de40&scoped=true&"
import script from "./indicatorType.vue?vue&type=script&lang=js&"
export * from "./indicatorType.vue?vue&type=script&lang=js&"
import style0 from "./indicatorType.vue?vue&type=style&index=0&id=dc86de40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc86de40",
  null
  
)

export default component.exports